export default {
  data() {
    return {
      showFileError: false,
      fileErrors: [],
    };
  },
  methods: {
    handleFileError(file) {
      // Add the errored file to the array
      this.fileErrors = [...this.fileErrors, file];
      // Show the modal
      this.showFileError = true;
    },
    closeErrors() {
      // Hide the error modal and clear the errored item array
      this.showFileError = false;
      this.fileErrors = [];
    },
    tryUploadAgain() {
      // TODO AK: refactor this using component $refs once quill is removed to allow
      // for multiple instances of AttachmentHandler and better component separation
      document.querySelector(`#${this.attachmentHandlerId}`).click(); // Auto-click the input
      this.closeErrors();
    },
  },
};
